<br />
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
    <p style="color: white"> {{'products.spinner.signingyouin' | translate}}</p>
</ngx-spinner>